<template>
  <div>
    <medical-plan
      v-if="student"
      :consent-services="consentServices"
      :is-read-only="isReadOnly"
      :services="services"
      :student="student"
      :sign-services="signServices"
      :signature-hub-services="signatureHubServices"
      @back="back"
    />
  </div>
</template>

<script>
import { parentModule } from '@/store/modules';
import {
  getPlanTypes,
  get,
  save,
  getHistory,
  getConsent,
  searchConsent,
  saveConsent,
  markSigned,
  saveMechanism,
  saveSignedDocument,
} from '@/services/medical-plan';
import generalService from '@/services/pei/general';
import documentsService from '@/services/documents';
import reportService from '@/services/report';
import {
  getSignatureHubInfo,
  removeSignatureHub,
} from '@/services/signatureHub/api';

import MedicalPlan from 'medical-plan';

export default {
  name: 'MedicalPlanMain',
  components: { MedicalPlan },
  props: { studentSieId: { type: [String, Number], default: null } },
  data() {
    return {
      isReadOnly: false,
    };
  },
  computed: {
    ...parentModule.mapGetters(['getStudentById']),
    services() {
      return Object.freeze({
        getPlanTypes,
        get,
        save,
        getHistory,
        downloadFile: generalService.getDocument,
      });
    },
    consentServices() {
      return Object.freeze({
        get: getConsent,
        search: searchConsent,
        save: saveConsent,
        sign: markSigned,
        saveMechanism,
        saveSignedDocument,
      });
    },
    signServices() {
      return Object.freeze({
        download: documentsService.downloadFromServer,
        downloadTemplate: reportService.getMedicalPlanConsent,
      });
    },
    signatureHubServices() {
      return Object.freeze({
        get: getSignatureHubInfo,
        remove: removeSignatureHub,
      });
    },
    student() {
      if (!this.studentSieId) return null;

      const student = this.getStudentById(Number(this.studentSieId));
      if (!student) return null;

      return Object.freeze({
        id: student.studentSieId,
        name: student.name,
      });
    },
  },
  methods: {
    back() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style scoped lang="scss"></style>
